module.exports = __webpack_public_path__ + "img/Gruppenführer_Bel.b555e343.svg";